import { useMutation, useQueryClient } from '@tanstack/react-query';

import { diamondsApi } from '../api/diamonds-api';

import { diamondKeys } from './diamond-keys';

/** The supplier's stones stay in the pool without a supplier, so both lists refetch. */
export function useDeleteSupplier() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (supplierId: string) => diamondsApi.deleteSupplier(supplierId),
    meta: { successMessage: 'diamonds:toasts.supplierDeleted' },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: diamondKeys.all }),
  });
}
